import { DefaultButton, IconButton, Label, Link, Pivot, PivotItem, PrimaryButton } from '@fluentui/react';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import * as Api from '../../api/src';
import '../../css/components/test.scss';
import { useHistory, useParams } from 'react-router-dom';
import ModaProductSpecification from '../settings/products/modal/modalProductSpecification';
import ModalTest from '../tests/modal/modalTest';
import { LeftMenuContext } from '../../context/leftMenu.context';

const ProductsApi = new Api.ProductsApi();
interface ParamTypes {
  id: string;
}
const ProductDetail = () => {
  let { id } = useParams<ParamTypes>();
  let routerHistory = useHistory();
  const { t } = useTranslation();
  const [detail, SetDetail] = React.useState<Api.ProductModel>({ States: Api.StatesEnum.Active });
  const { setSelectedMenuItem } = React.useContext(LeftMenuContext);

  React.useEffect(() => {
    getItemData(parseInt(id));
    setSelectedMenuItem("Product");
  }, []);
  const [isOpenModal, SetIsOpenModal] = React.useState(false);
  const [isOpenModalTest, SetIsOpenModalTest] = React.useState(false);
  const [itemSelected, SetItemSelected] = React.useState<Api.ProductSpecificationResponseModel>({});
  const getItemData = async (Id?: number) => {
    var data = (await ProductsApi.apiProductsIdGet(Id || 0)).data;
    SetDetail(data.Data || { States: Api.StatesEnum.Active });
  };
  return (
    <div className="test test-detail">
      <div className={'page-header flex-center'}>
        <IconButton
          iconProps={{ iconName: 'ChromeBack' }}
          onClick={() => {
            routerHistory.push('/products');
          }}
        />{' '}
        <Label>{detail.Name}</Label>
      </div>
      <Pivot className="tab-header" style={{ overflowY: 'hidden', overflowX: 'auto' }}>
        <PivotItem headerText={t('General')} itemKey={'General'}>
          <div className="test-detail margin-left-0 margin-right-0 page-content">
            <div className="ms-Grid padding-right-0" dir="ltr">
              <div className="ms-Grid-row">
                <div className="label ms-Grid-col">
                  <Label>{t('Model')}</Label>
                </div>
                <div className="ms-Grid-col">{detail.Name || '-'}</div>
              </div>
              <div className="ms-Grid-row">
                <div className="label ms-Grid-col">
                  <Label>{t('Category')}</Label>
                </div>
                <div className="ms-Grid-col">{detail.CategoryName || '-'}</div>
              </div>
              <div className="ms-Grid-row">
                <div className="label ms-Grid-col">
                  <Label>{t('GTIN')}</Label>
                </div>
                <div className="ms-Grid-col">{detail.GTIN || '-'}</div>
              </div>
              <div className="ms-Grid-row">
                <div className="label ms-Grid-col">
                  <Label>{t('ArticleNumber')}</Label>
                </div>
                <div className="ms-Grid-col">{detail.ArticleNumber || '-'}</div>
              </div>
              <div className="ms-Grid-row">
                <div className="label ms-Grid-col">
                  <Label>{t('Vendor')}</Label>
                </div>
                <div className="ms-Grid-col">{detail.VendorName || '-'}</div>
              </div>
              <div className="ms-Grid-row">
                <div className="label ms-Grid-col">
                  <Label>{t('Year')}</Label>
                </div>
                <div className="ms-Grid-col">{detail.Year || '-'}</div>
              </div>
              <div className="ms-Grid-row display-flex">
                <div className="label ms-Grid-col">
                  <Label>{t('Matrix')}</Label>
                </div>
                <div className="ms-Grid-col">{detail.Matrixs || '-'}</div>
              </div>
            </div>
          </div>
        </PivotItem>
        <PivotItem headerText={t('Specifications')} itemKey={'Specifications'}>
          <div className="test-detail margin-left-0 margin-right-0 page-content">
            <div className="ms-Grid padding-right-0" dir="ltr">
              <div className="ms-Grid" dir="ltr">
                <div className="ms-Grid-row flex-center">
                  <div className="ms-Grid-col ms-lg12" style={{ textAlign: 'right' }}>
                    <PrimaryButton text="Update specifications" onClick={() => SetIsOpenModal(true)} allowDisabledFocus />
                  </div>
                </div>
              </div>

              <div className="ms-Grid" dir="ltr">
                {detail.Specifications?.map((item) => {
                  return (
                    <div key={item.ComponentName} className="ms-Grid-row flex-center">
                      <div className="ms-Grid-col ms-lg4">{item.ComponentName}</div>
                      <div className="ms-Grid-col ms-lg6">{item.CModelName || '-'}</div>
                      <div className="ms-Grid-col ms-lg1">
                        <Link onClick={() => {
                          if (item.Tests === 0)
                            return;
                          routerHistory.push(`/tests/${item.CModelId}/${detail.ProductTypeId}`);
                        }}>
                          {(item.Tests || 0) <= 0 ? '-' : (item.Tests || 0) > 1 ? `${item.Tests} tests` : `${item.Tests} test`}
                        </Link>
                      </div>
                      <div className="ms-Grid-col ms-lg2" style={{ textAlign: 'right' }}>
                        <DefaultButton text="Add test" onClick={() => {
                          SetItemSelected(item);
                          SetIsOpenModalTest(true)
                        }} allowDisabledFocus />
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </PivotItem>
      </Pivot>

      {isOpenModal && (
        <ModaProductSpecification
          IsOpen={isOpenModal}
          ProductId={detail.Id ?? 0}
          Item={detail.Specifications ?? []}
          onCloseModal={() => {
            SetIsOpenModal(false);
          }}
          onSaveClick={() => {
            getItemData(parseInt(id));
          }}
        ></ModaProductSpecification>
      )}

      <ModalTest
        productypeId={detail.ProductTypeId || null}
        IsOpen={isOpenModalTest}
        Item={null}
        Data={{ ComponentId: itemSelected.ComponentId, CBrandId: itemSelected.CBrandId, CModelId: itemSelected.CModelId, VendorId: detail.VendorId }}
        onSaveClick={() => {
          getItemData(parseInt(id));
        }}
        onCloseModal={() => {
          SetIsOpenModalTest(false);
        }}
      ></ModalTest>

    </div>
  );
};
export default ProductDetail;
